export const ADYEN_API_KEY = import.meta.env.VITE_ADYEN_API_KEY as string;
// export const ADYEN_API_KEY = 'AQEthmfxKY7KaxxGw0m/n3Q5qf3Ve4ZICIdQa0QOkywGSAvAQUZ7mIBF48+iVDTMEMFdWw2+5HzctViMSCJMYAc=-0TiYuozWJ/2uL2bYirC1j5tHKsqgBz+0vgP/ztVewfU=-@LFX:XT=ZqU9=3*m';
export const ADYEN_ENVIRONMENT = import.meta.env.VITE_ADYEN_ENVIRONMENT as
  | "LIVE"
  | "TEST";

export const B2B_IFRAME_URL = `https://${
  import.meta.env.VITE_ENV === "prod" ? "" : import.meta.env.VITE_ENV + "-"
}app.smeetz.com/order/`;
